
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-100 py-12 text-center">
      <h3 className="font-serif-display italic text-3xl mb-4 text-black">H & J</h3>
      <p className="text-xs tracking-[0.3em] font-medium text-gray-400 uppercase mb-8">
        13.06.2026 • Enterkine House
      </p>
      <div className="flex justify-center space-x-6 mb-8">
        <span className="w-1.5 h-1.5 bg-[#F5F2ED] rounded-full" />
        <span className="w-1.5 h-1.5 bg-[#D4C4A8] rounded-full" />
        <span className="w-1.5 h-1.5 bg-[#F5F2ED] rounded-full" />
      </div>
      <p className="text-[10px] tracking-widest text-gray-300 uppercase font-light">
        Made with love for Heather & Jordan
      </p>
    </footer>
  );
};
